/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const AlertTriangle = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 19 16" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M18.82 13.55L11.09 1a1.79 1.79 0 0 0-3.18 0L.18 13.55A1.72 1.72 0 0 0 1.77 16h15.46a1.72 1.72 0 0 0 1.59-2.45zm-1.16.92a.42.42 0 0 1-.37.2H1.7a.42.42 0 0 1-.37-.2.37.37 0 0 1 0-.37L9.06 1.56v-.05a.42.42 0 0 1 .39-.24.41.41 0 0 1 .39.24v.05l7.85 12.54a.4.4 0 0 1-.03.37zM9.5 4.66a.65.65 0 0 0-.68.61v3.45a.68.68 0 0 0 1.36 0V5.27a.65.65 0 0 0-.68-.61zm.5 6.86a.73.73 0 0 0-1 0 .78.78 0 0 0-.15.22.75.75 0 0 0 0 .26.74.74 0 0 0 0 .25.66.66 0 0 0 .15.22.69.69 0 0 0 .48.19.73.73 0 0 0 .48-.19.66.66 0 0 0 .15-.22.74.74 0 0 0 0-.25.75.75 0 0 0 0-.26.78.78 0 0 0-.11-.22z" />
      </g>
    </svg>
  </span>
);

AlertTriangle.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

AlertTriangle.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default AlertTriangle;
